import { encryptedPost } from "../utils/secureApi";

/**
 * Boot service — single batched fetch for master-data needed right after login.
 * Both MasterDataContext and CategoryCacheContext subscribe to this shared
 * promise, so `/boot/master-data` fires at most once per page load.
 */

let bootPromise = null;

/**
 * Fires /boot/master-data at most once, shared across all callers.
 * Returns a promise resolving to { companies, stores, categories }.
 * Returns null for any field the user does not have permission to read.
 */
export function fetchBootMasterData() {
  if (bootPromise) return bootPromise;
  bootPromise = encryptedPost("/boot/master-data", {})
    .then((res) => (res?.errCode === 0 && res.data ? res.data : null))
    .catch(() => null);
  return bootPromise;
}

/**
 * Reset the cached promise — call on logout so the next login re-fetches.
 */
export function resetBootCache() {
  bootPromise = null;
}
